import { useEffect } from "react";

import { BusinessServiceType } from "@/common/enums/sharedEnums";

import ColoredMarker from "./ColoredMarker";
import { businessServiceTypeLabelsMin } from "../../modules/serviceOrdering/constants";

type BusinessServiceTypeMinProps = {
  businessType?: BusinessServiceType;
  label?: string;
};

const BusinessServiceTypeMin = ({
  businessType,
  label = "",
}: BusinessServiceTypeMinProps) => {
  useEffect(() => {
  }, [businessType, label]);
  const value = label
    ? label
    : businessServiceTypeLabelsMin[businessType as BusinessServiceType];
  return <ColoredMarker color="#000D5B">{value}</ColoredMarker>;
};

export default BusinessServiceTypeMin;
